var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"squizzy-squid"},[_c('img',{staticStyle:{"max-width":"200px","max-height":"139px","width":"auto","height":"auto"},attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }